import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIos } from "react-icons/md";
import { withLang } from "../utils/localePath";

const PreviousSectionCard = ({ label, to }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section
      onClick={() => {
        navigate(withLang(to));
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      className="
        w-full flex items-center justify-between
        gap-3 border border-[#475569] px-4 py-3 cursor-pointer
        transition-all duration-200 group
        hover:border-[#0087FE] font-normal
      "
    >
      <MdArrowBackIos
        className="
          text-[18px]
          text-black dark:text-white
          transition-colors duration-200
          group-hover:text-[#0087FE]
        "
      />

      {/* LABEL + subtext */}
      <div className="flex flex-col desktop:gap-1 text-right">
        <span className="tracking-wide text-[#64748B] dark:text-[#64748B] text-[14px] mobile:text-[12px] mini_mobile:text-[12px] font-normal">
          {t("common.previous")}
        </span>

        <span
          className="
            text-[16px] mobile:text-[14px] mini_mobile:text-[14px] text-[#334155] dark:text-[#E2E8F0]
            transition-colors duration-200
            group-hover:text-[#0087FE] font-normal
          "
        >
          {label}
        </span>
      </div>
    </section>
  );
};

export default PreviousSectionCard;
